module.exports = __webpack_public_path__ + "img/tcly@2X.d9431b30.png";